<template>
  <BgImageLayout title="License qualifiers labels" :page="__guide.licenseQualifiers" icon-color="white">
    <AgGridWrapper
      ref="wrapper"
      :options="agGridOptions"
      :actions="actions"
      separator
      include-search-box
      needs-update-preprocessing
      @requested-update="updateRow"
      @refresh-data="getQualifierLabels"
      @show-modal="createModal = true"
    />

    <CreateModal
      v-model="createModal"
      :options="qualifierLabels ? qualifierLabels.termLabels : []"
      @new-label="labelCreated"
    />
  </BgImageLayout>
</template>

<script>
import * as apiTo from '@/modular-api'
import agGridOptions from './agGridOptions'
// Libraries
import { cloneDeep } from 'lodash'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import CreateModal from './components/CreateModal'
import { deleteAgGridRow } from '@/reusable/ConfirmationDialog/delete-ag-grid-row'

export default {
  components: {
    AgGridWrapper,
    CreateModal
  },

  mixins: [agGridOptions],

  data() {
    return {
      qualifierLabels: null,
      createModal: false
    }
  },

  computed: {
    termLabelOptions() {
      if (!this.qualifierLabels) {
        return
      }
      return this.generateOptions({ collection: this.qualifierLabels.termLabels })
    },

    actions() {
      return [
        {
          label: 'Create New License Qualifier Label',
          event: 'show-modal',
          type: 'button',
          color: 'tertiary',
          size: 'md'
        }
      ]
    }
  },

  created() {
    this.getQualifierLabels()
  },

  methods: {
    getQualifierLabels() {
      apiTo.GET_QUALIFIER_LABELS().then(({ data }) => (this.qualifierLabels = data.result))
    },

    delete(params) {
      deleteAgGridRow(params, 'GET_QUALIFIER_LABEL_DELETE_CONFIRMATION', 'DELETE_QUALIFIER_LABEL', () => {
        const index = this.qualifierLabels.labels.findIndex(l => l.id === params.data.id)
        if (~index) this.qualifierLabels.labels.splice(index, 1)
      })
    },

    updateRow(payload) {
      const itemForUpdate = cloneDeep(payload.item)
      itemForUpdate.term_label = itemForUpdate.term_label.id
      apiTo.UPDATE_QUALIFIER_LABEL(payload.item.id, itemForUpdate).then(({ data }) => {
        const index = this.qualifierLabels.labels.findIndex(l => l.id === payload.item.id)
        if (~index) this.qualifierLabels.labels.splice(index, 1, data.result)
      })
    },

    labelCreated(newLabel) {
      this.qualifierLabels.labels.push(newLabel)
    }
  }
}
</script>
